import type { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import type { AppWidgetsPageStyles } from "../types";

export function buildWidgetsPageStyles(theme: Theme): AppWidgetsPageStyles {
  return {
    editPreviewRoot: {
      flex: 1,
      minHeight: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    editPreviewHeader: { flexShrink: 0 },
    editPreviewBody: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
    },
    editPreviewFrame: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.5,
      p: 1,
    },
    editPreviewPayload: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.5,
      p: 1,
      overflow: "hidden",
      bgcolor: alpha(theme.palette.background.default, 0.35),
    },
    editPreviewPlaceholder: {
      flex: 1,
      minHeight: 160,
      border: "1px dashed",
      borderColor: "divider",
      borderRadius: 1.5,
      p: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    editPendingAlert: { mb: 2, py: 0.5 },
    editModeToggle: { textTransform: "none", px: 1.5, fontSize: 12 },
  };
}
